import { render, staticRenderFns } from "./SalesPartnershipUsers.vue?vue&type=template&id=6a28e622&scoped=true&"
import script from "./SalesPartnershipUsers.vue?vue&type=script&lang=js&"
export * from "./SalesPartnershipUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28e622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
